function Input({
    value,
    onChange,
}) {
    return <div className="flex flex-col w-full">
        <input type="checkbox" className="toggle" checked={value} onChange={({ target: { checked }})=>onChange(checked)} />
    </div>
}
export default Input;
